import React, { useState, useEffect } from 'react';
import { passagemService, hotelService, hotelParceiroService } from '../services/api';
import { toast } from 'react-toastify';

function Aprovacoes() {
    const [passagens, setPassagens] = useState([]);
    const [hoteis, setHoteis] = useState([]);
    const [hoteisParceiros, setHoteisParceiros] = useState([]);
    const [loading, setLoading] = useState(true);

    const [modalAberto, setModalAberto] = useState(false);
    const [tipoModal, setTipoModal] = useState(null);
    const [itemSelecionado, setItemSelecionado] = useState(null);
    const [observacao, setObservacao] = useState('');

    const [dadosAprovacao, setDadosAprovacao] = useState({
        localEmbarque: '',
        localEmbarqueVolta: '',
        companhiaAerea: '',
        dataIda: '',
        dataVolta: '',
        valor: '',
        dataEntrada: '',
        dataSaida: '',
        nomeHotel: '',
    });

    useEffect(() => {
        carregarPendentes();
        carregarHoteisParceiros();
    }, []);

    const carregarPendentes = async () => {
        try {
            setLoading(true);
            const [resPassagens, resHoteis] = await Promise.all([
                passagemService.listarPendentes(),
                hotelService.listarPendentes()
            ]);
            setPassagens(resPassagens.data);
            setHoteis(resHoteis.data);
        } catch (error) {
            toast.error('Erro ao carregar solicitações pendentes');
        } finally {
            setLoading(false);
        }
    };

    const carregarHoteisParceiros = async () => {
        try {
            const res = await hotelParceiroService.listarTodos();
            setHoteisParceiros(res.data);
        } catch (error) {
            console.error('Erro ao carregar hotéis parceiros');
        }
    };

    const abrirModalAprovar = (tipo, item) => {
        setTipoModal(tipo === 'passagem' ? 'aprovar-passagem' : 'aprovar-hotel');
        setItemSelecionado(item);
        setDadosAprovacao({
            localEmbarque: '',
            localEmbarqueVolta: '',
            companhiaAerea: '',
            dataIda: '',
            dataVolta: '',
            valor: '',
            dataEntrada: '',
            dataSaida: '',
            nomeHotel: ''
        });
        setModalAberto(true);
    };

    const abrirModalRejeitar = (tipo, id) => {
        setTipoModal('rejeitar');
        setItemSelecionado({ tipo, id });
        setObservacao('');
        setModalAberto(true);
    };

    // quando seleciona um hotel parceiro, preenche o nome automaticamente
    const handleSelecionarHotelParceiro = (e) => {
        const id = e.target.value;
        if (!id) {
            setDadosAprovacao({ ...dadosAprovacao, nomeHotel: '' });
            return;
        }
        const hotel = hoteisParceiros.find(h => String(h.id) === id);
        if (hotel) {
            setDadosAprovacao({ ...dadosAprovacao, nomeHotel: hotel.nome });
        }
    };

    const handleConfirmarAprovacao = async () => {
        try {
            if (tipoModal === 'aprovar-passagem') {
                await passagemService.atualizar(itemSelecionado.id, {
                    solicitanteNome: itemSelecionado.solicitanteNome,
                    solicitanteRegistro: itemSelecionado.solicitanteRegistro,
                    destino: itemSelecionado.destino,
                    motivo: itemSelecionado.motivo,
                    localEmbarque: dadosAprovacao.localEmbarque,
                    localEmbarqueVolta: dadosAprovacao.localEmbarqueVolta,
                    companhiaAerea: dadosAprovacao.companhiaAerea,
                    dataIda: dadosAprovacao.dataIda || null,
                    dataVolta: dadosAprovacao.dataVolta || null,
                    valor: dadosAprovacao.valor ? Number(dadosAprovacao.valor) : null,
                });
                await passagemService.aprovar(itemSelecionado.id);
                toast.success('✅ Passagem aprovada!');
            } else {
                await hotelService.atualizar(itemSelecionado.id, {
                    solicitanteNome: itemSelecionado.solicitanteNome,
                    solicitanteRegistro: itemSelecionado.solicitanteRegistro,
                    motivo: itemSelecionado.motivo,
                    nomeHotel: dadosAprovacao.nomeHotel,
                    dataEntrada: dadosAprovacao.dataEntrada || null,
                    dataSaida: dadosAprovacao.dataSaida || null,
                    valor: dadosAprovacao.valor ? Number(dadosAprovacao.valor) : null,
                });
                await hotelService.aprovar(itemSelecionado.id);
                toast.success('✅ Reserva aprovada!');
            }
            setModalAberto(false);
            carregarPendentes();
        } catch (error) {
            toast.error(error.response?.data || '❌ Erro ao aprovar');
        }
    };

    const handleConfirmarRejeicao = async () => {
        try {
            if (itemSelecionado.tipo === 'passagem') {
                await passagemService.rejeitar(itemSelecionado.id, observacao);
                toast.success('Passagem rejeitada');
            } else {
                await hotelService.rejeitar(itemSelecionado.id, observacao);
                toast.success('Reserva rejeitada');
            }
            setModalAberto(false);
            carregarPendentes();
        } catch (error) {
            toast.error(error.response?.data || '❌ Erro ao rejeitar');
        }
    };

    if (loading) return <div>Carregando...</div>;

    const totalPendentes = passagens.length + hoteis.length;

    return (
        <div>
            <div className="d-flex align-items-center mb-4">
                <h2 className="mb-0">⏳ Aprovações</h2>
                {totalPendentes > 0 && (
                    <span className="badge bg-warning text-dark ms-3 fs-6">
                        {totalPendentes} pendente{totalPendentes > 1 ? 's' : ''}
                    </span>
                )}
            </div>

            {totalPendentes === 0 && (
                <div className="alert alert-success">✅ Nenhuma solicitação pendente!</div>
            )}

            {/* PASSAGENS */}
            {passagens.length > 0 && (
                <div className="card mb-4">
                    <div className="card-header">
                        <h5 className="mb-0">
                            ✈️ Passagens Pendentes
                            <span className="badge bg-warning text-dark ms-2">{passagens.length}</span>
                        </h5>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-striped table-hover">
                                <thead className="table-dark">
                                    <tr>
                                        <th>Solicitante</th>
                                        <th>Registro</th>
                                        <th>Destino</th>
                                        <th>Motivo</th>
                                        <th className="text-center">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {passagens.map((p) => (
                                        <tr key={p.id}>
                                            <td>{p.solicitanteNome || '-'}</td>
                                            <td>{p.solicitanteRegistro || '-'}</td>
                                            <td>{p.destino}</td>
                                            <td>{p.motivo || '-'}</td>
                                            <td className="text-center text-nowrap">
                                                <button onClick={() => abrirModalAprovar('passagem', p)} className="btn btn-sm btn-success me-2">✅ Aprovar</button>
                                                <button onClick={() => abrirModalRejeitar('passagem', p.id)} className="btn btn-sm btn-danger">❌ Rejeitar</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}

            {/* HOTÉIS */}
            {hoteis.length > 0 && (
                <div className="card mb-4">
                    <div className="card-header">
                        <h5 className="mb-0">
                            🏨 Reservas Pendentes
                            <span className="badge bg-warning text-dark ms-2">{hoteis.length}</span>
                        </h5>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-striped table-hover">
                                <thead className="table-dark">
                                    <tr>
                                        <th>Solicitante</th>
                                        <th>Registro</th>
                                        <th>Motivo</th>
                                        <th className="text-center">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {hoteis.map((h) => (
                                        <tr key={h.id}>
                                            <td>{h.solicitanteNome || '-'}</td>
                                            <td>{h.solicitanteRegistro || '-'}</td>
                                            <td>{h.motivo || '-'}</td>
                                            <td className="text-center text-nowrap">
                                                <button onClick={() => abrirModalAprovar('hotel', h)} className="btn btn-sm btn-success me-2">✅ Aprovar</button>
                                                <button onClick={() => abrirModalRejeitar('hotel', h.id)} className="btn btn-sm btn-danger">❌ Rejeitar</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL */}
            {modalAberto && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {tipoModal === 'rejeitar' ? '❌ Rejeitar Solicitação' : '✅ Aprovar Solicitação'}
                                </h5>
                                <button className="btn-close" onClick={() => setModalAberto(false)} />
                            </div>

                            <div className="modal-body">

                                {/* APROVAR PASSAGEM */}
                                {tipoModal === 'aprovar-passagem' && (
                                    <>
                                        <div className="mb-3">
                                            <label className="form-label">Local de Embarque (Ida)</label>
                                            <input type="text" className="form-control"
                                                placeholder="Ex: Aeroporto de Guarulhos"
                                                value={dadosAprovacao.localEmbarque}
                                                onChange={e => setDadosAprovacao({ ...dadosAprovacao, localEmbarque: e.target.value })} />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Companhia Aérea</label>
                                            <input type="text" className="form-control" list="companhias-aereas"
                                                placeholder="Digite ou escolha"
                                                value={dadosAprovacao.companhiaAerea}
                                                onChange={e => setDadosAprovacao({ ...dadosAprovacao, companhiaAerea: e.target.value })} />
                                            <datalist id="companhias-aereas">
                                                <option value="Gol" />
                                                <option value="Latam" />
                                                <option value="Azul" />
                                                <option value="Voepass" />
                                                <option value="Ita Transportes Aéreos" />
                                            </datalist>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Local de Embarque (Volta)</label>
                                            <input type="text" className="form-control"
                                                placeholder="Ex: Aeroporto de Congonhas"
                                                value={dadosAprovacao.localEmbarqueVolta}
                                                onChange={e => setDadosAprovacao({ ...dadosAprovacao, localEmbarqueVolta: e.target.value })} />
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Data de Ida *</label>
                                                <input type="date" className="form-control" required
                                                    value={dadosAprovacao.dataIda}
                                                    onChange={e => setDadosAprovacao({ ...dadosAprovacao, dataIda: e.target.value })} />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Data de Volta</label>
                                                <input type="date" className="form-control"
                                                    value={dadosAprovacao.dataVolta}
                                                    onChange={e => setDadosAprovacao({ ...dadosAprovacao, dataVolta: e.target.value })} />
                                                <small className="text-muted">Deixe vazio se for só ida</small>
                                            </div>
                                        </div>
                                    </>
                                )}

                               {/* APROVAR HOTEL */}
{tipoModal === 'aprovar-hotel' && (
    <>
        <div className="mb-3">
            <label className="form-label">Hotel Parceiro</label>
            {hoteisParceiros.length > 0 ? (
                <select
                    className="form-select"
                    onChange={handleSelecionarHotelParceiro}
                    defaultValue=""
                >
                    <option value="">Selecione um parceiro ou digite abaixo</option>
                    {hoteisParceiros.map(h => (
                        <option key={h.id} value={h.id}>
                            {h.nome} — {h.local}
                        </option>
                    ))}
                </select>
            ) : (
                <div className="alert alert-warning py-2">
                    ⚠️ Nenhum hotel parceiro cadastrado. Cadastre em Cadastro → Hotéis Parceiros.
                </div>
            )}
        </div>

        {/* campo manual só aparece se não selecionou parceiro */}
        {!dadosAprovacao.nomeHotel && (
            <div className="mb-3">
                <label className="form-label">Nome do Hotel <span className="text-muted">(manual)</span></label>
                <input type="text" className="form-control"
                    placeholder="Ex: Hotel Ibis Centro"
                    value={dadosAprovacao.nomeHotel}
                    onChange={e => setDadosAprovacao({ ...dadosAprovacao, nomeHotel: e.target.value })} />
            </div>
        )}

        {/* mostra o hotel selecionado */}
        {dadosAprovacao.nomeHotel && (
            <div className="alert alert-info py-2 mb-3 d-flex justify-content-between align-items-center">
                <span>🏨 <strong>{dadosAprovacao.nomeHotel}</strong></span>
                <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => setDadosAprovacao({ ...dadosAprovacao, nomeHotel: '' })}
                >
                    Trocar
                </button>
            </div>
        )}

        <div className="row">
            <div className="col-md-6 mb-3">
                <label className="form-label">Data de Entrada *</label>
                <input type="date" className="form-control" required
                    value={dadosAprovacao.dataEntrada}
                    onChange={e => setDadosAprovacao({ ...dadosAprovacao, dataEntrada: e.target.value })} />
            </div>
            <div className="col-md-6 mb-3">
                <label className="form-label">Data de Saída *</label>
                <input type="date" className="form-control" required
                    value={dadosAprovacao.dataSaida}
                    onChange={e => setDadosAprovacao({ ...dadosAprovacao, dataSaida: e.target.value })} />
            </div>
        </div>
    </>
)}

                                {/* REJEITAR */}
                                {tipoModal === 'rejeitar' && (
                                    <>
                                        <label className="form-label">
                                            Motivo da rejeição <span className="text-muted">(opcional)</span>
                                        </label>
                                        <input type="text" className="form-control"
                                            placeholder="Ex: Orçamento excedido..."
                                            value={observacao}
                                            onChange={e => setObservacao(e.target.value)}
                                            autoFocus />
                                    </>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setModalAberto(false)}>
                                    Cancelar
                                </button>
                                {tipoModal === 'rejeitar' ? (
                                    <button className="btn btn-danger" onClick={handleConfirmarRejeicao}>
                                        Rejeitar
                                    </button>
                                ) : (
                                    <button className="btn btn-success" onClick={handleConfirmarAprovacao}>
                                        Aprovar
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Aprovacoes;